import * as Config from '@/Config';
import * as Factory from '@/App/Factory';
import ChalkySticks from '@chalkysticks/sdk';

export class AppServiceProvider extends ChalkySticks.Core.Provider.ServiceProvider {
	/**
	 * Register bindings into the container.
	 *
	 * @return void
	 */
	public register(): void {
		console.log('Register has executed');

		// Logger
		this.container.instance('logger', ChalkySticks.Utility.Log.getDefaultInstance());

		// Nearby Venues
		this.container.singleton('nearbyVenueCollection', () => {
			const venueCollection = Factory.Venue.collection({ limit: 8 }).cache(Config.App.CACHE_GENERAL_TTL);
			venueCollection.fetch();
			venueCollection.cid = 'singleton-nearby-venue-collection';

			return venueCollection;
		});

		// this.container.singleton('feature-flags', () => {
		// 	return new FeatureFlagService({
		// 		defaults: {
		// 			darkMode: true,
		// 			newDashboard: false,
		// 		},
		// 	});
		// });
	}

	/**
	 * Boot-time initialization after all providers have registered.
	 *
	 * @return void
	 */
	public boot(): void {
		const logger = this.container.make<ChalkySticks.Utility.Log>('logger');

		const venueCollection = this.container.make<ChalkySticks.Collection.Venue>('nearbyVenueCollection');

		venueCollection.on('success', () => {
			console.log('Nearby venues fetched successfully:', venueCollection);
		});

		logger.info('app', 'AppServiceProvider booted', venueCollection.cid);
	}
}
